import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-wa-drop-down',
	templateUrl:'./WaDropDownPage.html',
	styles: [],
	styleUrls:['./WaDropDownPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class WaDropDownPage
{
	mdContent_335 = `\`\`\`java
import com.jwebmp.webawesome.components.button.WaDropDown;
\`\`\``;
	mdContent_336 = `\`\`\`java
new WaDropDown<>()
\`\`\``;
	mdContent_337 = `\`\`\`java
var dd = new WaDropDown<>();
dd.add(new WaButton<>("Options", Variant.Brand));
dd.add(new WaDropdownItem<>("Edit"));
dd.add(new WaDropdownItem<>("Delete"));
\`\`\``;
}
